import React,{Component} from "react";
import Header from "../components/Header";


class Agents extends React.Component{
    render(){
        return(
            <div>

                  {/*<!-- Header Container -->*/}
				  <Header agents="current"/>
                  {/*<!-- Header Container / End -->*/}

                  {/*<!-- Titlebar -->*/}
                  <div className="parallax titlebar" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1160.24px", backgroundPosition:"50% -550.067px"}}>
                    <div className="parallax-overlay" style={{backgroundColor:"rgb(48, 48, 48)", opacity: "0.8"}}></div>
                    <div id="titlebar">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Agents</h2>
                            {/*<!-- Breadcrumbs -->*/}
                            <nav id="breadcrumbs">
                              <ul>
                                <li><a href="index.html">Home</a></li>
                                <li>Agents Listings</li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/*<!-- Content -->*/}
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row"> 
                          <div className="utf-agents-container-area"> 
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-01.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-02.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-03.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-04.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/}  
                			
                			{/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-05.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-06.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-07.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-08.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/}  
                			
                			{/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-09.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-10.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-01.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/} 
                            
                            {/*<!-- Agent -->*/}
                            <div className="grid-item col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <div className="agent">
                                <div className="utf-agent-avatar"> <a href="agents-profile.html"> <img src="assets/images/agent-02.jpg" alt=""/> <span className="view-profile-btn">View Profile</span> </a> </div>
                                <div className="utf-agent-content">
                                  <div className="utf-agent-name">
                                    <h4><a href="agents-profile.html">John Williams</a></h4>
                                    <span>Agent In Afghanistan</span> 
                				  </div>                  
                                </div>
                              </div>
                            </div>
                            {/*<!-- Agent / End -->*/}  	
                          </div>
                          {/*<!-- Agents Container / End -->*/}           
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="clearfix"></div>
                        {/*<!-- Pagination -->*/}
                        <div className="utf-pagination-container margin-top-20">
                          <nav className="pagination">
                            <ul>
                              <li><a href="#"><i className="fa fa-angle-left"></i></a></li>
                			  <li><a href="#" className="current-page">1</a></li>
                			  <li><a href="#">2</a></li>
                			  <li><a href="#">3</a></li>
                			  <li className="blank">...</li>
                			  <li><a href="#">10</a></li>
                			  <li><a href="#"><i className="fa fa-angle-right"></i></a></li>
                            </ul>
                          </nav>          
                        </div>
                        {/*<!-- Pagination / End -->*/} 
                      </div>
                    </div>
                  </div>
                  <div style={{paddingTop:"15px", paddingBottom:"15px",}}></div>                  
            </div>
        )
    }
}

export default Agents;